/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type BulkUpdatePhaseDeliverablesInput = {
    projectId?: string | null | undefined;
    phaseDeliverables?: Array<BulkUpdatePhaseDeliverableInput | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type BulkUpdatePhaseDeliverableInput = {
    id?: string | null | undefined;
    phaseId?: string | null | undefined;
    deliverableId?: string | null | undefined;
    projectId?: string | null | undefined;
};
export type bulkUpdatePhaseDeliverablesMutationVariables = {
    input: BulkUpdatePhaseDeliverablesInput;
};
export type bulkUpdatePhaseDeliverablesMutationResponse = {
    readonly bulkUpdatePhaseDeliverables: {
        readonly phaseDeliverables: ReadonlyArray<{
            readonly id: string;
        } | null> | null;
    } | null;
};
export type bulkUpdatePhaseDeliverablesMutation = {
    readonly response: bulkUpdatePhaseDeliverablesMutationResponse;
    readonly variables: bulkUpdatePhaseDeliverablesMutationVariables;
};



/*
mutation bulkUpdatePhaseDeliverablesMutation(
  $input: BulkUpdatePhaseDeliverablesInput!
) {
  bulkUpdatePhaseDeliverables(input: $input) {
    phaseDeliverables {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "BulkUpdatePhaseDeliverablesInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BulkUpdatePhaseDeliverablesPayload",
    "kind": "LinkedField",
    "name": "bulkUpdatePhaseDeliverables",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PhaseDeliverable",
        "kind": "LinkedField",
        "name": "phaseDeliverables",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkUpdatePhaseDeliverablesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bulkUpdatePhaseDeliverablesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "bulkUpdatePhaseDeliverablesMutation",
    "operationKind": "mutation",
    "text": "mutation bulkUpdatePhaseDeliverablesMutation(\n  $input: BulkUpdatePhaseDeliverablesInput!\n) {\n  bulkUpdatePhaseDeliverables(input: $input) {\n    phaseDeliverables {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c74f9205c2b34983394a046c76c33ec1';
export default node;
